import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AddressType } from '@max/address/models/enums/address-type.enum';
import { AuthService } from '@max/auth/services/auth.service';
import { CommercialVehiclePermitModalComponent } from '@max/commercialpermitting/components/shared/commercial-vehicle-permit-modal/commercial-vehicle-permit-modal.component';
import { HistoricalCommercialVehiclePermitNumberContext, HistoricalCommercialVehiclePermitNumberModalComponent } from '@max/commercialpermitting/components/shared/historical-commercial-vehicle-permit-number-modal/historical-commercial-vehicle-permit-number-modal.component';
import { OutOfJurisdictionRegistrationHistoryModalComponent, OutOfJurisdictionRegistrationHistoryModalData } from '@max/commercialpermitting/components/shared/out-of-jurisdiction-registration-history-modal/out-of-jurisdiction-registration-history-modal.component';
import { OutOfJurisdictionRegistrationModalComponent, OutOfJurisdictionRegistrationModalData } from '@max/commercialpermitting/components/shared/out-of-jurisdiction-registration-modal/out-of-jurisdiction-registration-modal.component';
import { CommercialVehiclePermitNumberModel } from '@max/commercialpermitting/models/commercial-vehicle-permit-number.model';
import { CopyCommercialPermitModel } from '@max/commercialpermitting/models/copy-commercial-permit.model';
import { OutOfJurisdictionRegistrationModel } from '@max/commercialpermitting/models/out-of-jurisdiction-registration.model';
import { CommercialOutOfJurisdictionRegistrationService } from '@max/commercialpermitting/services/commercial-out-of-Jurisdiction-registration.service';
import { CustomerDetailModalComponent, CustomerDetailModalContext } from '@max/customer/detail/customer-detail-modal/customer-details-modal.component';
import { CustomerAddress } from '@max/customer/models/customer-address.model';
import { CustomerType } from '@max/customer/models/enums/customer-type.enum';
import { BusinessTransactionType } from '@max/foundation/models/enums/business-transaction-type.enum';
import { County } from '@max/foundation/models/enums/county.enum';
import { Jurisdiction } from '@max/foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '@max/shared/base-components/base.component';
import { OmegaDetailData, OmegaDetailModalComponent, UpdateType } from '@max/shared/components/omega/omega-details-update-modal.component';
import { scrollElementBelowHeader } from '@max/shared/helpers/scroll-helpers.model';
import { BusinessTransactionService } from '@max/shared/services/business-transaction/business-transaction.service';
import { RedirectTransactionService } from '@max/shared/services/business-transaction/redirect-transaction.service';
import { ModalSize } from '@max/shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '@max/shared/services/modal/mvd-modal.service';
import { AlertModalComponent, AlertModalData } from '@max/titleregistration/components/shared/alert-modal/alert-modal.component';
import { TitleHistoryContextData, TitleHistoryModalComponent } from '@max/titleregistration/components/shared/title/title-history/title-history-modal.component';
import { VehicleOwnershipDeInsuranceModalComponent, VehicleOwnershipDeInsuranceModalData } from '@max/titleregistration/components/shared/vehicle-ownership-de-insurance/vehicle-ownership-de-insurance-modal/vehicle-ownership-de-insurance-modal.component';
import { CustomerModel } from '@max/titleregistration/models/customer.model';
import { EmissionAreaType } from '@max/titleregistration/models/enums/emission-area-type.enum';
import { EmissionCertificateType } from '@max/titleregistration/models/enums/emission-certificate-type.enum';
import { EmissionTestResultType } from '@max/titleregistration/models/enums/emission-test-result-type.enum';
import { EmissionTestType } from '@max/titleregistration/models/enums/emission-test-type.enum';
import { FleetType } from '@max/titleregistration/models/enums/fleet-type.enum';
import { InsurancePolicySourceType } from '@max/titleregistration/models/enums/insurance-policy-source-type.enum';
import { InsurancePolicyType } from '@max/titleregistration/models/enums/insurance-policy-type.enum';
import { LegalStatusType } from '@max/titleregistration/models/enums/legal-status-type.enum';
import { OdometerReadingType } from '@max/titleregistration/models/enums/odometer-reading-type.enum';
import { OdometerReadingUnitType } from '@max/titleregistration/models/enums/odometer-reading-unit-type.enum';
import { OwnershipCompositeServiceEnum } from '@max/titleregistration/models/enums/owership-composite.enum';
import { OwnershipRoleType } from '@max/titleregistration/models/enums/ownership-role-type.enum';
import { TitleSourceType } from '@max/titleregistration/models/enums/title-source-type.enum';
import { TitleStatusType } from '@max/titleregistration/models/enums/title-status-type.enum';
import { VehicleOwnershipDeInsuranceReasonType } from '@max/titleregistration/models/enums/vehicle-ownership-de-insurance-reason-type.enum';
import { FleetModel } from '@max/titleregistration/models/fleet.model';
import { GameAndFishDecalModel } from '@max/titleregistration/models/game-and-fish-decal.model';
import { InsuranceSearchResultModel } from '@max/titleregistration/models/insurance-search-result.model';
import { LienModel } from '@max/titleregistration/models/lien.model';
import { OwnershipCustomerRelationshipModel } from '@max/titleregistration/models/ownership-customer-relationship.model';
import { RegistrationModel } from '@max/titleregistration/models/registration.model';
import { TitleModel } from '@max/titleregistration/models/title.model';
import { VehicleEmissionCheckStatusRegistrationModel } from '@max/titleregistration/models/vehicle-emission-check-status-registration.model';
import { VehicleOwnershipSoldNoticeModel } from '@max/titleregistration/models/vehicle-ownership-sold-notice.model';
import { VehicleOwnershipModel } from '@max/titleregistration/models/vehicle-ownership.model';
import { DecalService } from '@max/titleregistration/services/decal.service';
import { FleetService } from '@max/titleregistration/services/fleet.service';
import { InsuranceService } from '@max/titleregistration/services/insurance.service';
import { OwnershipService } from '@max/titleregistration/services/ownership.service';
import { SoldNoticeService } from '@max/titleregistration/services/sold-notice.service';
import { TitleRegistrationCustomerService } from '@max/titleregistration/services/titleregistration-customer.service';
import { TitleRegistrationService } from '@max/titleregistration/services/titleregistration.service';
import { VehicleEmissionsService } from '@max/titleregistration/services/vehicle-emissions.service';
import { VehicleOwnershipDeInsuranceService } from '@max/titleregistration/services/vehicle-ownership-de-insurance.service';
import { NewBusinessTransaction } from '@max/transaction/models/new-business-transaction.model';
import { CheckinService } from '@max/transaction/services/checkin.service';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { catchError, concatMap, filter, first, flatMap } from 'rxjs/operators';
import { CommercialPermitNumberModel } from '../../../../../commercialpermitting/models/commercial-permit-number.model';
import { CommercialVehiclePermitType } from '../../../../../commercialpermitting/models/enums/commercial-vehicle-permit-type.enum';
import { CommercialPermitService } from '../../../../../commercialpermitting/services/commercial-permit.service';
import { CustomerAccountService } from '../../../../../customer/account/service/customer-account.service';
import { AccessControlType } from '../../../../../foundation/models/enums/access-control-type.enum';
import { MotorCarrierAccountTPAFeeSummaryModalComponent } from '../../../../../irp/shared/components/motor-carrier-account-tpa-fee-summary/motor-carrier-account-tpa-fee-summary-modal.component';
import { NoteViewModel } from '../../../../../note/models/views/note-view.model';
import { NoteManageService } from '../../../../../note/note-manage.service';
import { NoteComponent } from '../../../../../note/note.component';
import { ActionTopic } from '../../../../../shared/services/dispatcher/action-topic.enum';
import { TitleRegistrationUserService } from '../../../../../titleregistration/services/titleregistration-user.service';
import { AlternativeFuelTierType } from '../../../../models/enums/alternative-fuel-tier-type.enum';
import { BodyStyleType } from '../../../../models/enums/body-style-type.enum';
import { Brand } from '../../../../models/enums/brand.enum';
import { FuelType } from '../../../../models/enums/fuel-type.enum';
import { TonnageRatingType } from '../../../../models/enums/tonnage-rating-type.enum';
import { VINType } from '../../../../models/enums/v-i-n-type.enum';
import { VehiclePermitStatusType } from '../../../../models/enums/vehicle-permit-status-type.enum';
import { VehiclePermitType } from '../../../../models/enums/vehicle-permit-type.enum';
import { VehicleType } from '../../../../models/enums/vehicle-type.enum';
import { VehicleWatchContactModel } from '../../../../models/vehicle-watch-contact.model';
import { VehicleModel } from '../../../../models/vehicle.model';
import { VehicleService } from '../../../../services/vehicle.service';
import { IssueSoldNoticeModalComponent, IssueSoldNoticeModalData } from '../issue-sold-notice-modal/issue-sold-notice-modal.component';
import { VehicleEmissionsModalComponent, VehicleEmissionsModalData } from '../vehicle-emissions-modal/vehicle-emissions-modal.component';
import { WatchYourCarModalComponent, WatchYourVehicleData } from './watch-your-car.modal.component';
import { forkJoin, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { TitleCancelReasonType } from '../../../../../titleregistration/models/enums/title-cancel-reason-type.enum';
import { DocumentItemKeyType } from '../../../../../Foundation/models/enums/document-item-key-type.enum';
import { DocumentSearchContext, DocumentSearchModalComponent } from '../../../../../shared/components/document/document-search-modal.component';
import { DocumentUploadData, DocumentUploadModalComponent } from '../../../../../shared/components/document/document-upload-modal.component';
import { DocumentSearchCriteria } from '../../../../../shared/models/document/document-search-criteria.model';
import { DocumentItemKeyData } from '../../../../../shared/models/document/document-itemkey.model';
import { TRPCancelReasonType, ITRPCancelReasonType } from '../../../../models/enums/t-r-p-cancel-reason-type.enum';
import { RequiredDocumentDetailsModel } from '@max/shared/models/document/required-document-details.model';
import { DocumentCategoryType } from '@max/Foundation/models/enums/document-category-type.enum';
import { DocumentRequirementType } from '@max/shared/enums/document-requirement-type.enum';
import { DocumentType } from '@max/Foundation/models/enums/document-type.enum';

@Component({
    selector: 'vehicle-information',
    templateUrl: './vehicle-information.html'
})
export class VehicleInformationComponent extends BaseComponent {
    @Input() includeHeader = true;
    @Input() vehicleId: number;

    public viewContainer: ViewContainerRef;
    /**
     * Ownership model for the vehicle
     */
    public vehicleOwnershipModel: VehicleOwnershipModel;

    /**
     * Emissions information for the vehicle
     */
    public vehicleEmissionCheckStatusRegistration: VehicleEmissionCheckStatusRegistrationModel;

    /**
     * Vehicle model for the vehicle being shown
     */
    public vehicle: VehicleModel;

    /**
     * Array of all permit status types
     */
    public permitStatusTypes = new VehiclePermitStatusType().GetAll();

    /**
     * Vehicle watch contact model
     */
    public vehicleWatchContactModel: VehicleWatchContactModel;

    /**
     * List of all insurance search results for the vehicle
     */
    public insuranceSearchResults: InsuranceSearchResultModel[];

    /**
     * Current registration model for the vehicle
     */
    public registration: RegistrationModel;

    /**
     * Fleet model for fleet the vehicle is a part of
     */
    public fleet: FleetModel;

    /**
     * Game and Fish decals for the vehicle
     */
    public decals: GameAndFishDecalModel[];

    // Commercial permit view Model.
    public commercialVehiclePermitNumberViewModels: CommercialVehiclePermitNumberModel[];

    /**
     * Indicator if all the data has been loaded for the page
     */
    public dataLoaded = false;

    /**
     * Enum for Ownership Role Types
     */
    private ownershipRoleType: OwnershipRoleType = new OwnershipRoleType();

    /**
     * Array of all ownership role types
     */
    public ownershipRoleTypes = new OwnershipRoleType().GetAll();

    /**
     * Array of all ownership de-insurance reason types
     */
    public vehicleOwnershipDeInsuranceReasonTypes = new VehicleOwnershipDeInsuranceReasonType().GetAll();

    /**
     * Array of all body style types
     */
    public bodyStyleTypes = new BodyStyleType().GetAll();

    /**
     * Array of all counties
     */
    public counties = new County().GetAll();

    /**
     * Array of all customer types
     */
    public customerTypes = new CustomerType().GetAll();

    /**
     * Array of all title status types
     */
    public titleStatusTypes = new TitleStatusType().GetAll();

    /**
     * Array of all fleet types
     */
    public fleetTypes = new FleetType().GetAll();

    /**
     * Array of all fuel types
     */
    public fuelTypes = new FuelType().GetAll();

    /**
     * Array of all tonnage rating types
     */
    public tonnageRatingTypes = new TonnageRatingType().GetAll();

    /**
     * Vehicle type enums
     */
    public vehicleType: VehicleType = new VehicleType();

    /**
     * Array of all vehicle types
     */
    public vehicleTypes = new VehicleType().GetAll();

    /**
     * Array of all emission test result types
     */
    public emissionTestResultTypes = new EmissionTestResultType().GetAll();

    /**
     * Array of all emission area types
     */
    public emissionAreaTypes = new EmissionAreaType().GetAll();

    /**
     * Array of all emission certificate types
     */
    public emissionCertificateTypes = new EmissionCertificateType().GetAll();

    /**
     * Array of all emission test types
     */
    public emissionTestTypes = new EmissionTestType().GetAll();

    /**
     * Array of all odometer reading types
     */
    public odometerReadingTypes = new OdometerReadingType().GetAll();

    /**
     * Array of all odometer reading unit types
     */
    public odometerReadingUnitTypes = new OdometerReadingUnitType().GetAll();

    /**
     * Array of all jurisdictions
     */
    public jurisdictions = new Jurisdiction().GetAll();

    /**
     * Array of all vehicle permit types
     */
    public vehiclePermitTypes = new VehiclePermitType().GetAll();

    /**
     * Array of all brands
     */
    public brands = new Brand().GetAll();

    /**
     * Array of all VIN types
     */
    public vinTypes = new VINType().GetAll();

    /**
     * Array of all legal status types
     */
    public legalStatusTypes = new LegalStatusType().GetAll();

    /**
     * Array of all address types
     */
    public addressTypes = new AddressType().GetAll();

    /**
     * Array of all tilte source types
     */
    public titleSourceTypes = new TitleSourceType().GetAll();
    public insurancePolicyTypes = new InsurancePolicyType().GetAll();
    public insurancePolicySourceTypes = new InsurancePolicySourceType().GetAll();
    public alternativeFuelTierTypes = new AlternativeFuelTierType().GetAll();

    public showCMLPermits: boolean;

    public accessControlTypes = new AccessControlType();

    /*
     * Permit Notes variables
     */
    public permitId: number;
    public permitSelected = false;
    public activePermitNotes = new Array<NoteViewModel>();
    public isOIGFraudNoteExisted = false;

    /**
     * Out Of Jurisdiction Registration variables
     */
    public activeOutOfJurisdictionRegistration: OutOfJurisdictionRegistrationModel[] = [];

    @ViewChild(NoteComponent) noteComponent: NoteComponent;

    public isUserAssociatedToVehicle = false;
    public isMobileHome = false;
    public isTitleCanceledWithAffixedReason = false;
    private titleCancelReasonTypes: TitleCancelReasonType = new TitleCancelReasonType();
    public trpCancelReasonTypes: ITRPCancelReasonType[] = new TRPCancelReasonType().GetAll();

    private documentItemKeyType = new DocumentItemKeyType();
    documentItemKeyCollection: DocumentItemKeyData[] = [];
    searchDocumentDataCollection: DocumentSearchCriteria[] = [];
    public canUploadToMobileHomeRecord = false;
    private documentCategoryType = new DocumentCategoryType();
    private documentRequirementType = new DocumentRequirementType();
    private documentType = new DocumentType();

    constructor(
        private _vehicleService: VehicleService,
        private route: ActivatedRoute,
        private _titleRegistrationService: TitleRegistrationService,
        public modalService: MvdModalService,
        private soldNoticeService: SoldNoticeService,
        private _ownershipService: OwnershipService,
        private _vehicleOwnershipDeInsuranceService: VehicleOwnershipDeInsuranceService,
        private decalService: DecalService,
        private fleetService: FleetService,
        private _titleRegistrationCustomerService: TitleRegistrationCustomerService,
        private router: Router,
        private insuranceService: InsuranceService,
        private vehicleEmissionService: VehicleEmissionsService,
        private _authService: AuthService,
        private _customerAccountService: CustomerAccountService,
        private commercialPermitService: CommercialPermitService,
        private checkinService: CheckinService,
        private businessTransactionService: BusinessTransactionService,
        private redirectTransactionService: RedirectTransactionService,
        private noteManageService: NoteManageService,
        private outOfJurisdictionRegistrationService: CommercialOutOfJurisdictionRegistrationService,
        private toastService: MessageService,
        private titleRegistrationUserService: TitleRegistrationUserService
    ) {
        super();
    }

    /**
     * Initializes the component data
     */
    public ngOnInit(): void {
        this.toastService.clear();

        if (this.vehicleId) {
            forkJoin({
                vehicleOwnership: this._titleRegistrationService.getActiveVehicleOwnership(this.vehicleId, OwnershipCompositeServiceEnum.Customer, OwnershipCompositeServiceEnum.InsuranceReported, OwnershipCompositeServiceEnum.Registration, OwnershipCompositeServiceEnum.Title, OwnershipCompositeServiceEnum.Vehicle),
                userCustomerNumbers: this.titleRegistrationUserService.getCustomerUserAgentCustomerNumbers().pipe(catchError(e => of(e)))
            }).subscribe(async r => {
                if (r.vehicleOwnership && r.vehicleOwnership.vehicle) {
                    this.determineIfUserIsAssociatedToVehicle(r);
                    this.vehicleOwnershipModel = <VehicleOwnershipModel> r.vehicleOwnership;
                    // Fetch notes and check is there any one of the note has OIG Confidentatial
                    // then change th ViewNotes button color CC #113466
                    this.getNotes();

                    this.vehicle = this.vehicleOwnershipModel.vehicle;
                    if (this.vehicleOwnershipModel.vehicleOwnershipPlate) {
                        this.registration = this.vehicleOwnershipModel.vehicleOwnershipPlate.registration;
                        this.registration.vehicleOwnershipPlate = this.vehicleOwnershipModel.vehicleOwnershipPlate;
                        this.vehicleEmissionCheckStatusRegistration = this.registration.vehicleEmissionCheckStatusRegistration;
                        this.populateInsuranceSearchResultsWithInsuranceReported();
                    } else {
                        this.registration = null;
                        this.populateInsuranceSearchResults();
                    }

                    if (this.vehicleOwnershipModel.title && this.vehicleOwnershipModel.title.titleCancel && this.vehicleOwnershipModel.title.titleCancel.titleCancelReasonTypeId === this.titleCancelReasonTypes.AffixedMobileHome.id) {
                        this.isTitleCanceledWithAffixedReason = true;
                    }
                } else {
                    this.vehicle = await this._vehicleService.getVehicleComposite(this.vehicleId).pipe(first()).toPromise();
                    // query insurance for this vehicle
                    this.populateInsuranceSearchResults();
                }

                if (this.vehicle) {
                    this.isMobileHome = this.vehicle.vehicleTypeID === this.vehicleType.MobileHome.id;

                    // get permit customers. refer CC 54542
                    if (this.vehicle.vehiclePermits && this.vehicle.vehiclePermits.length) {

                        var basicCustomerIds = this.vehicle.vehiclePermits.map(p => p.customerNumberId);

                        this._titleRegistrationCustomerService.getBasicCustomers(basicCustomerIds).subscribe(c => {
                            let basicCustomers: CustomerModel[] = c;
                            for (var permit of this.vehicle.vehiclePermits) {
                                for (var basicCustomer of basicCustomers) {
                                    if (permit.customerNumberId === basicCustomer.customerNumberID) {
                                        permit.customer = basicCustomer;
                                        break;
                                    }
                                }
                            }
                        });

                        for (var i = 0; i < this.vehicle.vehiclePermits.length; i++) {
                            if (this.vehicle.vehiclePermits[i].customerAccountNumberId) {
                                let details = await this._customerAccountService.getCustomerAccountDetails(this.vehicle.vehiclePermits[i].customerAccountNumberId).pipe(first()).toPromise();
                                this.vehicle.vehiclePermits[i].description = details.accountDescription;
                            } else {
                                this.vehicle.vehiclePermits[i].description = '';
                            }
                        }
                    }

                    if (!this.registration) {
                        this.vehicleEmissionCheckStatusRegistration = new VehicleEmissionCheckStatusRegistrationModel();
                    }

                    this.vehicleEmissionCheckStatusRegistration.vehicleEmissionTest = await this.vehicleEmissionService.getLatestEmissionTestByVehicleId(this.vehicleId).pipe(first()).toPromise();
                }
            },
            error => this.handleValidationResult(error));

            this._ownershipService.getVehicleWatchContact(this.vehicleId).subscribe(r => {
                if (r && r.phone1) {
                    this.vehicleWatchContactModel = <VehicleWatchContactModel> r;
                    // format the string coming from conversion. refer bug 48093
                    var phone1 = this.vehicleWatchContactModel.phone1;
                    var phone2 = this.vehicleWatchContactModel.phone2;

                    if (phone1 && phone1.length === 10) {
                        var phone = phone1.substr(0, 3) + '-' + phone1.substr(3, 3) + '-' + phone1.substr(6); // Create format with substring
                        this.vehicleWatchContactModel.phone1 = phone;
                    }
                    if (phone2 && phone2.length === 10) {
                        var phone = phone2.substr(0, 3) + '-' + phone2.substr(3, 3) + '-' + phone2.substr(6); // Create format with substring
                        this.vehicleWatchContactModel.phone2 = phone;
                    }
                }
            });

            this.decalService.getDecalsByVehicleId(this.vehicleId).subscribe(r => {
                this.decals = <GameAndFishDecalModel[]> r;
            });

            this.fleetService.getFleetByVehicleId(this.vehicleId).subscribe(
                r => {
                    this.fleet = r;
                }
            );

            this.loadNestedLazyComponents();

            this.populateCommercialPermitInformation(this.vehicleId, 0); // First page.
            this.populateActiveOutOfStateJurisdictionRegistration(this.vehicleId);
            this.canUploadToMobileHomeRecord = this.auth.hasACSTransactionClaimEx(this.auth.acsTransactionClaim, this.accessControlTypes.UploadToMobileHomeRecord.value);
            this.dataLoaded = true;

        }
    }

    private populateCommercialPermitInformation(vehicleId, pageNumber) {
        this.commercialPermitService.getCommercialPermitVehicleInformation(vehicleId, pageNumber).subscribe(r => {
            this.commercialVehiclePermitNumberViewModels = r.result;

            if (this.commercialVehiclePermitNumberViewModels && this.commercialVehiclePermitNumberViewModels.length > 0) {
                this.commercialVehiclePermitNumberViewModels = this.commercialVehiclePermitNumberViewModels.slice(0, 5); // Per US
            }

            this.showCMLPermits = true;
        });
    }

    private populateActiveOutOfStateJurisdictionRegistration(vehicleId: number) {
        this.outOfJurisdictionRegistrationService.getActiveOutOfJurisdictionRegistration(vehicleId).subscribe(r => {
            if (r) {
                this.activeOutOfJurisdictionRegistration.push(r);
            }
        });
    }

    private loadNestedLazyComponents() {
        this.router.navigate([{
            outlets: {
                withdrawal: ['manage-pace', this.vehicleId],
                registration: ['registration-info', this.vehicleId]
            }
        }], { relativeTo: this.route });
    }

    private populateInsuranceSearchResultsWithInsuranceReported() {
        let self = this;
        if (self.vehicleOwnershipModel && self.vehicleOwnershipModel.insurancePolicyReported) {
            self.insuranceSearchResults = new Array<InsuranceSearchResultModel>();
            var model = new InsuranceSearchResultModel();

            model.insuranceCompanyName = self.vehicleOwnershipModel.insurancePolicyReported.insuranceCompanyName;
            model.insurancePolicyNumber = self.vehicleOwnershipModel.insurancePolicyReported.insurancePolicyNumber;
            model.insurancePolicyTypeId = self.vehicleOwnershipModel.insurancePolicyReported.insurancePolicyTypeId;
            model.customer = new CustomerModel();
            model.customer.customerName = self.vehicleOwnershipModel.insurancePolicyReported.policyHolderName;
            model.insurancePolicySourceTypeId = self.vehicleOwnershipModel.insurancePolicyReported.insurancePolicySourceTypeId;
            model.notifyDate = self.vehicleOwnershipModel.insurancePolicyReported.notifyDate;
            model.effectiveDate = self.vehicleOwnershipModel.insurancePolicyReported.effectiveDate;
            model.endDate = self.vehicleOwnershipModel.insurancePolicyReported.endDate;
            self.insuranceSearchResults.push(model);
        }
    }

    private populateInsuranceSearchResults() {

        this.insuranceService.getInsuranceSearchResultsByVehicleId(this.vehicleId)
            .subscribe(results => {
                if (results.length > 0) {
                    this.setInsuranceSearchResults(results);
                }
            });
    }

    public beginService() {
        const customers = this.filteredCustomerList();
        if (Array.isArray(customers) && customers.length) {
            const firstCustomerNumber = customers[0].customerNumberID;
            const vehicleId = this.vehicleId;
            this.router.navigate(['/transaction/agent', firstCustomerNumber, { outlets: { 'body': ['serviceslist', firstCustomerNumber, 'vehicle', vehicleId], 'sidebar': ['servicesadd', firstCustomerNumber], 'head': ['info', firstCustomerNumber] } }]);
        }
    }

    public viewVehicleHistory() {
        this.router.navigateByUrl(`titleregistration/standalone/(body:vehicle-title-history/(aux/-1/${this.vehicle.vin}))`);
    }

    public viewVehicleNotes() {
        this.router.navigateByUrl(`titleregistration/standalone/(body:vehicle-ownership-note/(vehicleOwnerShipId/${this.vehicleOwnershipModel.id}/vehicleId/${this.vehicle.id}))`);
    }

    public viewVehicleDocuments() {
        let data: DocumentSearchContext = {
            documentItemKeyTypeId: new DocumentItemKeyType().Vehicle.id,
            itemKeyId: this.vehicleId,
            startDate: null,
            endDate: null,
            hideUserInput: true,
            disableSelect: true,
        };

        // open the modal
        this.modalService.open(DocumentSearchModalComponent, data, ModalSize.Large)
            .afterClosed()
            .subscribe(() => { });
    }

    public addVehicleDocuments() {
        const documentItemKeyData = new DocumentItemKeyData();
        documentItemKeyData.documentItemKeyTypeId = this.documentItemKeyType.Vehicle.id;
        documentItemKeyData.itemKeyId = this.vehicleId;
        this.documentItemKeyCollection.push(documentItemKeyData);

        const requiredDocumentDetails = new RequiredDocumentDetailsModel();
        requiredDocumentDetails.documentCategoryTypeId = this.documentCategoryType.All.id;
        requiredDocumentDetails.documentCategoryTypeDisplayValue = this.documentCategoryType.All.displayValue;
        requiredDocumentDetails.documentTypeId = this.documentType.AllTitleDocuments.id;
        requiredDocumentDetails.documentTypeDisplayValue = this.documentType.AllTitleDocuments.displayValue;
        requiredDocumentDetails.documentRequirementTypeId = this.documentRequirementType.SystemRequired.id;

        const data = new DocumentUploadData(this.searchDocumentDataCollection, this.documentItemKeyCollection, [requiredDocumentDetails]);
        data.isDocumentNameEditable = true;
        data.isDocumentRequirementEnabled = false;
        data.defaultSignatureRequired = false;
        data.isAddRequirementEnabled = false;
        this.modalService.open(DocumentUploadModalComponent, data);
    }

    public getNotes() {
        if (this.vehicleOwnershipModel.id != undefined) {
            this.noteManageService.isVehicleOwnershipHasOIGFraudNote(this.vehicleOwnershipModel.id).subscribe(
                response => {
                    this.isOIGFraudNoteExisted = (response && response.result == true) ? true : false;
                },
                e => console.log('error', e)
            );
        }
    }

    private setInsuranceSearchResults(insuranceSearchResults: InsuranceSearchResultModel[]) {
        let self = this;
        if (!self.insuranceSearchResults) {
            self.insuranceSearchResults = new Array<InsuranceSearchResultModel>();
        }

        // showing all vehicle insurance on this page for validation purposes
        // jeff origonally asked for special filtering on what to show for insurance, this may come back later
        if (insuranceSearchResults.length > 0) {
            if (insuranceSearchResults.find(i => i.endDate == null)) {
                self.insuranceSearchResults = insuranceSearchResults.filter(i => i.endDate == null);
            } else {
                let insurance = insuranceSearchResults[0];
                if (insurance.endDate == null) {
                    self.insuranceSearchResults.push(insurance);
                } else {
                    if (moment(insurance.endDate).toDate() > moment().toDate()) {
                        self.insuranceSearchResults.push(insurance);
                    }
                }
            }
        }
    }
    /**
     * Gets the customer address to render on screen out of the collection of address
     * @param customerAddresses: Array of customer addresses for the owner on the vehicle
     */
    getCustomerAddress(customer: CustomerModel) {
        if (customer && customer.mailingAddress) {
            return customer.mailingAddress;
        } else if (customer && customer.physicalAddress) {
            return customer.physicalAddress;
        } else {
            return new CustomerAddress();
        }
    }

    hasAddress(customer: CustomerModel): boolean {
        if (customer && customer.mailingAddress) {
            return true;
        } else if (customer && customer.physicalAddress) {
            return true;
        } else {
            return false;
        }
    }

    // refer CC 71221
    getLienEffectiveDate(customerNumberId: number, ownershipRoleTypeID: number): Date {
        if (!this.vehicleOwnershipModel || ownershipRoleTypeID != this.ownershipRoleType.Lienholder.id) {
            return null;
        }
        var title = this.vehicleOwnershipModel.title;
        if (title.liens && title.liens.length) {
            for (var lien of title.liens as LienModel[]) {
                let lienCustomer = lien.lienCustomers.find(c => c.ownershipCustomerRelationshipID == customerNumberId && c.ownershipRoleTypeID == this.ownershipRoleType.Lienholder.id);
                if (lienCustomer) {
                    return lien.lienEffectiveDate;
                }
            }
        }
        return null;
    }

    /**
     * Gets a list of customers with the lienholders filtered out.
     */
    filteredCustomerList(): OwnershipCustomerRelationshipModel[] {
        if (this.vehicleOwnershipModel && this.vehicleOwnershipModel.ownershipCustomerRelationships && !!this.vehicleOwnershipModel.ownershipCustomerRelationships.length) {
            let filteredList = this.vehicleOwnershipModel.ownershipCustomerRelationships.sort((n1, n2) => this.ownershipRoleType.FromId(n1.ownershipRoleTypeID).legalPriority - this.ownershipRoleType.FromId(n2.ownershipRoleTypeID).legalPriority || n1.ownershipRoleSequence - n2.ownershipRoleSequence);
            return filteredList;
        }

        return null;
    }

    /**
     * Refreshes the binding on the component
     */
    private refreshBinding() {
        this.vehicle = this.vehicleOwnershipModel.vehicle;
        this.dataLoaded = true;
    }

    /**
     * Launches the modal for the issue sold notice
     */
    issueSoldNotice() {
        const self = this;
        let callbeginservices = false;
        let vehicleOwnershipSoldNoticeRegistrationCreditCheck: any;
        const customers = this.filteredCustomerList();
        const customerNumber: number = customers ? customers[0].customerNumberID : null;
        const data = new IssueSoldNoticeModalData(self.vehicleId, customerNumber);
        this.modalService.open(IssueSoldNoticeModalComponent, data).afterClosed()
            .pipe(
                filter(result => result),
                flatMap(r => {
                    if (r.refundTotal) {
                        callbeginservices = true;
                        vehicleOwnershipSoldNoticeRegistrationCreditCheck = r;
                    }
                    return self._vehicleService.getActiveVehicleOwnershipByVehicleId(self.vehicleId);
                }),
            )
            .subscribe(
                r => {
                    self.vehicleOwnershipModel = r;
                    self.toastService.add({ severity: 'success', summary: 'Success', detail: 'Sold Notice saved successfully.' });
                    if (callbeginservices) {
                        this.startNewRegistrationCreditTransaction(vehicleOwnershipSoldNoticeRegistrationCreditCheck);
                    } else {
                        self.refreshBinding();
                    }
                },
                err => console.log(err)
            );
    }

    private startNewRegistrationCreditTransaction(vehicleOwnershipSoldNoticeRegistrationCreditCheck) {
        const businessTransaction = new NewBusinessTransaction();
        let businessTransactionNumberId: number;

        businessTransaction.businessTransactionAreaId = 3;
        businessTransaction.businessTransactionTypeId = new BusinessTransactionType().RequestRegistrationCredit.id;
        businessTransaction.customerNumberId = vehicleOwnershipSoldNoticeRegistrationCreditCheck.registrationMailToCustomerNumberId;
        businessTransaction.agentId = vehicleOwnershipSoldNoticeRegistrationCreditCheck.registrationMailToCustomerNumberId;
        businessTransaction.businessTransactionParamId = vehicleOwnershipSoldNoticeRegistrationCreditCheck.registrationIdEligibleForCredit;

        const newBusinessTransactions = new Array<NewBusinessTransaction>();
        newBusinessTransactions.push(businessTransaction);

        this.checkinService.checkin(null, businessTransaction.customerNumberId, newBusinessTransactions).pipe(
            concatMap(r => {
                businessTransactionNumberId = r.businessTransactionIds[0];
                return this.businessTransactionService.assignBusinessTransactionsToUser(businessTransactionNumberId.toString(), 0, true);
            }))
            .subscribe(
                () => {
                    this.redirectTransactionService.redirectToTransaction(businessTransactionNumberId.toString(), this.viewContainer);
                },
                error => console.log(error)
            );
    }

    /**
     * Launches the add de-insurance modal
     */
    addDeInsurance() {
        const self = this;

        self._vehicleOwnershipDeInsuranceService.newVehicleOwnershipDeInsurance(self.vehicleOwnershipModel.id).subscribe(
            r => {

                let customerNumberId: number;

                if (this.router.routerState.snapshot.url.includes('/customer/individual/') && this.route.snapshot.params.id) {
                    customerNumberId = this.route.snapshot.params.id;
                }
                const data = new VehicleOwnershipDeInsuranceModalData(r, 'Add De-Insurance', 'Add', true, customerNumberId);

                this.modalService.open(VehicleOwnershipDeInsuranceModalComponent, data).afterClosed()
                    .pipe(
                        filter(result => !!result),
                        flatMap(() => self._vehicleService.getActiveVehicleOwnershipByVehicleId(self.vehicleId))
                    )
                    .subscribe(
                        r => {
                            self.vehicleOwnershipModel = r;
                            self.dispatcher.publish({ topic: ActionTopic.RefreshWithdrawals, values: null });
                            self.toastService.add({ severity: 'success', summary: 'Success', detail: 'De-Insurance saved successfully.' });
                            self.refreshBinding();
                        },
                        err => {
                            console.log(err);
                        }
                    );
            },
            err => {
                console.log(err);
            }
        );
    }

    /**
     * Launches the modal to edit the vehicle de-insurance
     * @param id: vehicle de-insurance id
     */
    editVehicleDeInsurance(id: number) {
        const self = this;
        const deInsurance = self.vehicleOwnershipModel.vehicleOwnershipDeInsurances.filter(x => x.id == id)[0];
        var copy = Object.assign({}, deInsurance);
        const data = new VehicleOwnershipDeInsuranceModalData(copy, 'Update De-Insurance', 'Update', true);
        this.modalService.open(VehicleOwnershipDeInsuranceModalComponent, data).afterClosed()
            .pipe(
                filter(result => !!result),
                flatMap(() => self._vehicleService.getActiveVehicleOwnershipByVehicleId(self.vehicleId))
            )
            .subscribe(
                r => {
                    self.vehicleOwnershipModel = r;
                    self.toastService.add({ severity: 'success', summary: 'Success', detail: 'De-Insurance saved successfully.' });
                    self.refreshBinding();
                },
                err => console.log(err)
            );
    }

    /**
     * Removes the sold notice from the vehicle ownership
     */
    async removeSoldNotice() {
        const self = this;
        let soldNotice: VehicleOwnershipSoldNoticeModel = await this.soldNoticeService.removeSoldNotice(self.vehicleOwnershipModel.id).pipe(first()).toPromise();
        if (soldNotice != null) {
            self._vehicleService.getActiveVehicleOwnershipByVehicleId(self.vehicleId).subscribe(
                r => {
                    self.vehicleOwnershipModel = r;
                    self.refreshBinding();
                },
                err => {
                    self.toastService.add({ severity: 'error', summary: 'Error', detail: 'Error occured while getting vehicle ownership.' });
                }
            );
            if (soldNotice.validationResults == null || soldNotice.validationResults.length == 0) {
                self.toastService.add({ severity: 'success', summary: 'Success', detail: 'Sold Notice deleted successfully.' });
            } else {
                self.toastService.add({ severity: 'error', summary: 'Error', detail: soldNotice.validationResults[0].errorMessage });
            }
        } else {
            self.toastService.add({ severity: 'error', summary: 'Error', detail: 'Error occured while removing Sold Notice.' });
        }
    }

    /**
     * Navigate to insurance edit screen.
     */
    editInsurance() {
        this.router.navigate([`/vehicle/vehicle-insurance/${this.vehicle.id}`]);
    }

    getInsurance() {
        let self = this;
        this.insuranceService.checkMvsInsuranceClearIncidents(this.vehicleId)
            .subscribe(r => {
                let oldInsuranceSearchResults = self.insuranceSearchResults;
                self.insuranceSearchResults = new Array<InsuranceSearchResultModel>();
                self.insuranceSearchResults.push(r.result);
                if (r.validationResults.length > 0 && r.validationResults[0].state && r.validationResults[0].state.validationType == 'Information') {
                    self.toastService.add({ severity: 'success', summary: 'Success', detail: 'Insurance Confirmed ' + r.validationResults[0].errorMessage });
                } else {
                    self.toastService.add({ severity: 'success', summary: 'Success', detail: 'Insurance Confirmed' });
                    self._vehicleService.getActiveVehicleOwnershipByVehicleId(self.vehicleId).subscribe(vo => {
                        self.vehicleOwnershipModel = vo;
                    });
                }
                if (oldInsuranceSearchResults.length == 1) {
                    if (oldInsuranceSearchResults[0].insurancePolicyTypeId) {
                        self.insuranceSearchResults.push(oldInsuranceSearchResults[0]);
                    }
                } else if (oldInsuranceSearchResults.length >= 2) {
                    if (oldInsuranceSearchResults[1].insurancePolicyTypeId) {
                        self.insuranceSearchResults.push(oldInsuranceSearchResults[1]);
                    }
                }
            },
            err => {
                this.pushGrowlErrorMessage(err);
            }
            );
    }
    /**
     * Launches the title history modal
     */
    viewTitleHistory() {
        const title = 'Title History for ' + this.vehicle.makeDisplayValue + ' ' + this.vehicle.modelDisplayValue + ' VIN ' + this.vehicle.vin;
        const data = new TitleHistoryContextData(this.vehicleId, title);
        this.modalService.open(TitleHistoryModalComponent, data);
    }

    /**
     * Deletes the Watch Your Car entry for the vehicle
     */
    public async deleteWatchYourCar() {
        if (this.vehicleWatchContactModel) {
            await this._ownershipService.deleteVehicleWatchContact(this.vehicleId).pipe(first()).toPromise();
            this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Un-enrolled successfully.' });
            this.vehicleWatchContactModel = null;
        }
    }

    /**
     * Launches the modal to add a Watch Your Car entry for the vehicle
     */
    public async showVehicleWatchContactModal() {
        let tempVehicleWatchContactModel = this.vehicleWatchContactModel;

        if (!tempVehicleWatchContactModel) {
            tempVehicleWatchContactModel = new VehicleWatchContactModel();
        }

        const data = new WatchYourVehicleData(tempVehicleWatchContactModel, this.vehicleId);
        this.modalService.open(WatchYourCarModalComponent, data).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(async acceptedValue => {
                if (acceptedValue) {
                    this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Enrolled successfully.' });
                    this.vehicleWatchContactModel = await this._ownershipService.getVehicleWatchContact(this.vehicleId).pipe(first()).toPromise();
                }
            }, err => {
                this.toastService.add({ severity: 'error', summary: 'Error', detail: 'An error occured. Please try again.' });
            }
            );
    }

    public async editVehicleWatchContactModal() {
        var canEdit = await this._ownershipService.canEditVehicleWatchContact(this.vehicleId).pipe(first()).toPromise();
        if (!canEdit) {
            this.toastService.add({ severity: 'error', summary: 'Error', detail: 'Not enough permissions.' });
            return;
        }
        await this.showVehicleWatchContactModal();
    }

    /**
     * Shows the customer modal for the selected customer
     * @param customerNumberId: Customer number to show in modal
     */
    showCustomerSummaryModal(customerNumberId: number) {
        const data = new CustomerDetailModalContext(customerNumberId, true);
        this.modalService.open(CustomerDetailModalComponent, data);
    }

    /**
     * Formats the title issued date.  Will return an empty string if the date is 1/1/1900, as this
     * is a date from conversion that is used when the actual date is unknown.
     */
    public getFormattedTitleIssuedDate() {
        const vomTitle = <TitleModel> this.vehicleOwnershipModel.title;
        const issuedDate = moment(vomTitle.titleIssuedDate).toDate();
        if (issuedDate.getFullYear() === 0 || (issuedDate.getDate() === 1 && issuedDate.getMonth() === 0 && issuedDate.getFullYear() === 1900)) {
            return '';
        } else {
            return moment(vomTitle.titleIssuedDate).format('L');
        }
    }

    public launchUpdateDetailsModal() {
        const data = new OmegaDetailData(this.vehicleId, UpdateType.Vehicle);
        this.modalService.open(OmegaDetailModalComponent, data);
    }

    goTo(location: string) {
        const element = document.getElementById(location);
        scrollElementBelowHeader(element);
    }

    public async isApportionedChanged(event) {
        if (event.target.checked && this.registration && this.registration.registrationStatusTypeID == 1) {
            var bodyText = 'The vehicle registration will be canceled. Are you sure you want to continue?';

            var r = await this.modalService.confirm().title('IRP flag').body(bodyText)
                .okBtn('Yes').cancelBtn('No')
                .open().afterClosed().pipe(first
                ()).toPromise();

            try {
                if (r) {
                    await this._titleRegistrationService.setApportionedFlag(this.vehicle.id, this.vehicle.isApportioned).pipe(first()).toPromise();
                } else {
                    this.vehicle.isApportioned = false;
                }
            } catch (err) {
                this.pushGrowlErrorMessage(err);
            }

        } else {
            try {
                await this._titleRegistrationService.setApportionedFlag(this.vehicle.id, this.vehicle.isApportioned).pipe(first()).toPromise();
            } catch (err2) {
                this.pushGrowlErrorMessage(err2);
            }
        }

        this.dispatcher.publish({ topic: ActionTopic.VehicleInformationRefreshRegistration, values: null });
    }

    public pushGrowlErrorMessage(err) {
        if (err.error && err.error.validationResults && err.error.validationResults.length > 0 && err.error.validationResults[0].errorMessage) {
            this.toastService.add({ severity: 'error', summary: 'Error', detail: err.error.validationResults[0].errorMessage });
        }
    }
    /**
     * Verifies that the user has an access control type
     * @param acs
     */
    public userHasAccessControlType(acs: string): boolean {
        return this._authService.hasACSTransactionClaimEx(this._authService.acsTransactionClaim, acs);
    }

    public addVehicleEmissions() {
        const data: VehicleEmissionsModalData = { vehicle: this.vehicle, copyEmissionsTest: null };
        this.modalService.open(VehicleEmissionsModalComponent, data).afterClosed()
            .pipe(
                filter(result => !!result)
            )
            .subscribe(
                r => {
                    this.vehicleEmissionCheckStatusRegistration.vehicleEmissionTest = r;
                    this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Vehicle Emissions added successfully.' });
                    this.refreshBinding();
                },
                err => {
                    console.log(err);
                }
            );
    }

    public copyVehicleEmissions() {
        const data: VehicleEmissionsModalData = { vehicle: this.vehicle, copyEmissionsTest: JSON.parse(JSON.stringify(this.vehicleEmissionCheckStatusRegistration.vehicleEmissionTest)) };
        this.modalService.open(VehicleEmissionsModalComponent, data).afterClosed()
            .pipe(
                filter(result => !!result)
            )
            .subscribe(
                r => {
                    this.vehicleEmissionCheckStatusRegistration.vehicleEmissionTest = r;
                    this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Vehicle Emissions added successfully.' });
                    this.refreshBinding();
                },
                err => {
                    console.log(err);
                }
            );
    }

    public getCommercialPermitTypeDisplayValue(id) {
        let commercialPermitTypes = new CommercialVehiclePermitType;

        return commercialPermitTypes.FromId(id).displayValue;
    }

    /**
     * Launches the CML history modal
     */
    public viewCommercialVehiclePermitHistory() {
        const data = new HistoricalCommercialVehiclePermitNumberContext(this.vehicleId);
        this.modalService.open(HistoricalCommercialVehiclePermitNumberModalComponent, data);
    }

    public openCommercialVehiclePermitModal = (commercialVehiclePermitNumberId: number): void => {
        this.modalService.open(CommercialVehiclePermitModalComponent, commercialVehiclePermitNumberId, ModalSize.Medium);
    };

    public copyCommercialPermit = (permitNumber: number): void => {
        const data = new AlertModalData('Copy Permit', '', 'Are you sure you want to copy this permit to begin a new service?', 'Cancel', 'Continue', true);
        this.modalService.open(AlertModalComponent, data)
            .afterClosed()
            .subscribe(r => {
                if (r) {
                    this.getCommercialPermitDetails(permitNumber);
                }
            });
    };

    private getCommercialPermitDetails(commercialPermitNumberId: number) {
        this.commercialPermitService.getCommercialPermitDetailById(commercialPermitNumberId).subscribe(result => {
            if (result) {
                const copiedPermitData: CopyCommercialPermitModel = new CopyCommercialPermitModel();
                copiedPermitData.previousCommercialVehiclePermitNumberId = +result.id;
                copiedPermitData.customerNumberId = result.customerNumberId;
                copiedPermitData.vehicleIds = result.vehicleIds;
                copiedPermitData.permit = new CommercialPermitNumberModel();
                copiedPermitData.permit.commercialVehiclePermitTypeId = result.commercialVehiclePermitTypeId;
                copiedPermitData.permit.supplementTypeIds = result.supplementTypeIds;
                copiedPermitData.permit.customerNumberId = result.customerNumberId;
                copiedPermitData.commercialLoad = result.load;
                copiedPermitData.commercialLoadAxles = result.load.axles;
                copiedPermitData.commercialTrailers = result.trailers;
                copiedPermitData.commercialTrip = result.trip;
                copiedPermitData.requirements = result.requirements;
                copiedPermitData.additionalRequirements = result.additionalRequirements;
                this.startNewTransaction(copiedPermitData);
            }
        });
    }

    private startNewTransaction(previousPermitTransaction: CopyCommercialPermitModel) {
        const businessTransaction = new NewBusinessTransaction();
        let businessTransactionNumberId: number;
        const businessTransactionTypeId = new BusinessTransactionType().CommercialPermit.id;

        businessTransaction.businessTransactionAreaId = 12;
        businessTransaction.businessTransactionTypeId = businessTransactionTypeId;
        businessTransaction.customerNumberId = previousPermitTransaction.customerNumberId;
        businessTransaction.agentId = previousPermitTransaction.customerNumberId;
        businessTransaction.businessTransactionParamId = previousPermitTransaction.vehicleIds[0];

        const newBusinessTransactions = new Array<NewBusinessTransaction>();
        newBusinessTransactions.push(businessTransaction);

        this.checkinService.checkin(null, businessTransaction.customerNumberId, newBusinessTransactions).pipe(
            concatMap(r => {
                businessTransactionNumberId = r.businessTransactionIds[0];
                return this.businessTransactionService.assignBusinessTransactionsToUser(businessTransactionNumberId.toString(), 0, true);
            }))
            .subscribe(
                () => {
                    this.commercialPermitService.copyPreviousPermitToWip(businessTransactionNumberId, previousPermitTransaction).subscribe(() =>
                        this.redirectTransactionService.redirectToTransaction(businessTransactionNumberId.toString(), this.viewContainer)
                    );
                },
                error => console.log(error)
            );
    }

    public setPermitId(id) {
        this.permitId = id;
        this.permitSelected = true;
        if (this.noteComponent && this.dataLoaded) {
            this.noteComponent.noteIdentificationValue = this.permitId;
            this.noteComponent.notes = new Array<NoteViewModel>();
            this.noteComponent.reInitialize();
        }
    }

    public addOutOfStateRegistration() {
        const oosRegistration = new OutOfJurisdictionRegistrationModel();
        const data = new OutOfJurisdictionRegistrationModalData(oosRegistration, 'Add', this.vehicleId);
        this.modalService.open(OutOfJurisdictionRegistrationModalComponent, data).afterClosed()
            .subscribe(
                r => {
                    if (r) {
                        this.activeOutOfJurisdictionRegistration = [];
                        this.populateActiveOutOfStateJurisdictionRegistration(this.vehicleId);
                        this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Out of State Registration saved successfully.' });
                    }
                },
                err => console.log(err)
            );
    }

    public viewOutOfStateRegistrationHistory() {
        const data = new OutOfJurisdictionRegistrationHistoryModalData(this.vehicleId);
        this.modalService.open(OutOfJurisdictionRegistrationHistoryModalComponent, data).afterClosed()
            .subscribe(
            );
    }

    public editOutOfStateRegistration() {
        const oosRegistration = this.activeOutOfJurisdictionRegistration[0];
        const data = new OutOfJurisdictionRegistrationModalData(oosRegistration, 'Edit', this.vehicleId, true);
        this.modalService.open(OutOfJurisdictionRegistrationModalComponent, data).afterClosed()
            .subscribe(
                r => {
                    if (r) {
                        this.activeOutOfJurisdictionRegistration = [];
                        this.populateActiveOutOfStateJurisdictionRegistration(this.vehicleId);
                        this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Out of State Registration saved successfully.' });
                    }
                },
                err => console.log(err)
            );
    }

    public openTpaFeeSummaryModal(permitNumber: string) {
        let data = {};
        data['permitNumber'] = permitNumber;
        this.modalService.open(MotorCarrierAccountTPAFeeSummaryModalComponent, data)
            .afterClosed().pipe(filter(result => !!result))
            .subscribe();
    }

    private determineIfUserIsAssociatedToVehicle(result) {
        if (result.userCustomerNumbers instanceof HttpErrorResponse) {
            return;
        }
        let userCustomerNumbers = result.userCustomerNumbers as number[];
        let vehicleOwnership = result.vehicleOwnership as VehicleOwnershipModel;
        if (userCustomerNumbers.filter(x => vehicleOwnership.ownershipCustomerRelationships.some(y => x === y.customerNumberID)).length > 0) {
            this.isUserAssociatedToVehicle = true;
        }
    }
}
